<div class="animated fadeInRight" >
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo + ' - '+ this.label"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <!-- <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>-->
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->

    <!-- CUERPO -->
    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
        <div class="form-group col-md-12" *ngIf="!mostrarForm">
            <input class="form-control" placeholder="Buscar... " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id" 
                                [class] ="DAT_AG_GRID.class" 
                                [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [rowHeight]="DAT_AG_GRID.rowHeight"
                                [columnDefs]="columnDefs"
                                [rowClassRules]="rowClassRules"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [allowContextMenuWithControlKey]="true"
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
        </div>
        <!-- GRILLA -->

        <div *ngIf="mostrarForm">
            <div class="card mb-3 shadow-sm viaje-card" style="border: 1px solid #f1e4c3; border-left: 5px solid #f0ad4e; border-radius: 8px;">
                <div class="card-body p-3" *ngIf="rowData">
                    <div class="d-flex align-items-center flex-wrap mb-3 pb-2" style="border-bottom: 1px dashed #eadfc0;">
                        <div class="d-inline-flex align-items-center px-3 py-2" style="background:#fdf5e3; border-radius: 6px;">
                            <i class="fa fa-road" aria-hidden="true" style="color:#f0ad4e; font-size: 1.1rem;"></i>
                            <span class="font-weight-bold" style="font-size: 1rem; margin-left: 8px;">Viaje # {{ selected?.idViaje }}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-building" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Proveedor</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.proveedorNombre }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-car" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Placa</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.placa }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-truck" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Furgón</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.furgon }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-map-marker" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Número de Andén</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;"><span *ngIf="selected?.descripcionAnden">{{ selected?.descripcionAnden }}</span></div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-user" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Nombre del Chofer</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferNombre }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-phone" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Celular del Chofer</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferTelefono }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-map-marker" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Centro Destino</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.centroDestino }} - {{ selected?.centroDestinoNombre }} <span class="text-muted">({{ selected?.clienteNombre }})</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br>
        </div>
        <!-- FORMULARIO DE ANDENES  
        <div class="container-fluid row px-3" *ngIf="selected && !isOperador">
            <div class="row gx-5">
                <div class="col-md-6">                    
                    <form [formGroup]="formAnden" mat-dialog-content class="row p-3 border rounded">
                        <div class="row">
                            <h6> Asignación de Andenes</h6><br>
                            <div class="col">
                                <app-lfsa-combo-box [label]="'* Centro Carga Origen'" formControlName="centroOrigen" [control]="formAnden.get('centroOrigen')" 
                                                    [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm" [habilitar]="true">
                                </app-lfsa-combo-box>
                            </div>
                            <div class="col">
                                <app-lfsa-combo-box [label]="'* Bodega/Carga Origen'" formControlName="bodegaCarga" [control]="formAnden.get('bodegaCarga')" 
                                                    [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" [habilitar]="true">
                                </app-lfsa-combo-box>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <span *ngIf="CentroAlmacen == null"> No hay muelles el para Centro-almacen </span>
                                <app-lfsa-input formControlName="texto" [label]="'* Texto traslado Centro-Almacen'" [id]="'texto'" [control]="formAnden.get('texto')" 
                                [type]="'text'" class="form-control-sm" aria-readonly="true" [isReadOnly]="true" >
                                </app-lfsa-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <app-lfsa-combo-box [label]="'* Seleccionar anden'" id="andenId" formControlName="andenId" [control]="formAnden.get('andenId')" 
                                                    [comboBox]="listAdenes" [opcion]="'nombre'" [idOpcion]="'idMuelle'" class="form-control-sm" >
                                </app-lfsa-combo-box>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button (click)="estableEstados('anden')" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-check"></i> Agregar </button>
                            </div>
                        </div>                
                    </form>
                </div>

                <div class="col-md-6">
                    <form [formGroup]="formulario" mat-dialog-content class="row p-3 border rounded">
                        <div class="row">
                            <h6> Asignación de Sellos</h6><br>
                            <div class="row">
                                <div class="col-6">
                                    <app-lfsa-input formControlName="sellosAdd" [label]="'* Agregar sellos'" [id]="'sellosAdd'" [control]="formulario.get('sellosAdd')" 
                                    [type]="'text'" class="form-control-sm">
                                    </app-lfsa-input>
                                </div>
                                <div class="col">
                                    <label> </label>
                                    <div class="d-grid gap-2 d-md-block">
                                        <button (click)="agregarDetalleSellos()" class="btn btn-success" type="button"><i aria-hidden="true" class="fas fa-plus"></i></button>
                                        <button (click)="resetSellos()" class="btn btn-warning" type="button"> <i aria-hidden="true" class="fas fa-sync-alt"></i> </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                 <span class="badge text-bg-warning mx-2 w-20" *ngFor="let opcion of this.listSello; index as i" >{{ opcion }}</span>             
                                </div>
                                <br><br> 
                            </div>                             
                            <div class="row">
                                <div class="col">
                                    <app-lfsa-input formControlName="sellos" [label]="'* Sellos para viaje'" [id]="'sellos'" 
                                        [control]="formulario.get('sellos')" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                                    </app-lfsa-input>
                                </div>
                            </div> 
                            <div class="row">
                                <div class="col">
                                    <button (click)="estableEstados('anden')" class="btn btn-primary" 
                                            [disabled]="formulario.get('sellos').value == '' "> 
                                        <i aria-hidden="true" class="fa fa-check"></i>Guardar Sellos
                                    </button>
                                    <br>
                                </div>
                            </div>    
                        </div>
                    </form>
                    
                </div>
                <br>                
                <button (click)="accionesAnden('regresar')" class="btn btn-outline-danger btn-block col-md-4"><i class="fas fa-arrow-left"></i> Regresar</button>
                <div class="col-md-4"><span class="badge text-bg-success"></span></div>
                <button (click)="estableEstados('anden-fin')" class="btn btn-success btn-block col-md-4"><i class="fas fa-save"></i>{{textBotonGuardar}}</button>
            </div>
        </div>-->
        <!-- FORMULARIO DE ANDENES  -->

        <!-- FORMULARIO DE ASIGNAR PERSONAL  -->
        <div class="container-fluid row" *ngIf="mostrarForm">
            <div class="col">
                <form [formGroup]="formActividad" mat-dialog-content>
                    <h6>Actividad del Personal </h6>                  
                    <div class="row pt-3 pb-4 border rounded">
                        <div class="row">
                            <div class="col-md-6">
                                <app-lfsa-input formControlName="colaboradorNombre" [label]="'* Buscar por nombres'" [id]="'colaboradorNombre'" 
                                    (change)="getColaborador()" [control]="formActividad.get('colaboradorNombre')" class="form-control-sm" 
                                    [type]="'text'" class="form-control-sm" >
                                </app-lfsa-input>
                            </div>
                            <div class="col-md-2">
                                <div class="col form-group ">
                                    <label for="colaboradorCargo" class="form-control-sm">Rol-Cargo</label>
                                    <select class="form-control" formControlName="colaboradorCargo">
                                        <option value="">-- Seleccione --</option>
                                        <option value="VERIFICADOR">Verificador</option>
                                        <option value="MONTACARGISTA">Montacargista</option>
                                        <option value="CUADRILLA">Cuadrilla</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label class="form-control-sm">Tipo de Estiba</label>
                                <ng-select
                                    [items]="tiposEstibas"
                                    bindLabel="label"
                                    bindValue="id"
                                    formControlName="tipoEstiba"
                                    ngControl="formActividad.get('tipoEstiba')"
                                    placeholder="Seleccione un tipo de estiba"
                                    [clearable]="true"
                                    [appendTo]="'body'">
                                </ng-select>
                            </div>
                            <div class="col-md-2" style="display: flex; justify-content: start;align-items: center;">
                                <button [disabled]="formActividad.invalid" (click)="agregarDetalleColaborador()"  class={{DAT_BTNCSS.success}}>+</button>
                            </div>
                        </div>
                        <div class="row col-6">
                            <select class="form-control custom-select" formControlName="colaborador" name="colaborador" size="5" *ngIf="colaboradores">
                                <option value="" disabled>Seleccione un colaborador</option>
                                <option *ngFor="let cmb of colaboradores" [value]="cmb.cedula">{{cmb.nombres}}</option>
                            </select>
                        </div>
                        <br>
                        <!--tabla de registros-->
                        <div class="row">
                            <div class="mb-3" *ngIf="listColaborador.length == 0" style="text-align: center;">  Sin detalles </div>
                            <div *ngIf="listColaborador.length > 0">
                                <table class="table table-bordered table-hover" style="width: 100%;">
                                <thead><tr>
                                    <th>CEDULA</th>
                                    <th>NOMBRE</th>
                                    <th>CARGO/ROL</th>
                                    <th>VIAJE</th>
                                    <th>TIPO ESTIBA</th>
                                    <th> </th></tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of listColaborador; index as i">
                                    <td>{{ item.colaborador }}</td>
                                    <td>{{ item.colaboradorNombre }}</td>
                                    <td>{{ item.colaboradorCargo }}</td>
                                    <td>{{ item.viajeId }}</td>
                                    <td>{{ item.tipoEstiba }}</td>
                                    <td><button (click)="eliminarDetalleColaborador(i)" class={{DAT_BTNCSS.danger}}> X </button></td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                        <app-lfsa-botones-formulario  
                            (devolverAccion) ="acciones( $event )" 
                            [formularioValido] ="listColaborador.length == 0" 
                            [loading]="loading" 
                            [textBoton]="'Guardar lista'" class="row col-md-12">
                        </app-lfsa-botones-formulario>
                        <br>
                    </div>

                    <div class="alert alert-warning" role="alert" *ngIf="this.selected.estado === 'ANDEN_ASIGNADO'">
                        Antes de Iniciar a Cargar debe contar con una Cuadrilla
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>

                    <h6 class="mt-5">Adicionales y Finalizar </h6>
                    <div class="row pt-3 mb-4 border rounded">
                        <div class="col-md-4" *ngIf="this.selected.estado === 'ANDEN_CARGANDO' && this.selected.isSobrepeso">
                            <app-lfsa-combo-box [label]="'* Motivos de Bloqueo'" formControlName="motivoBloqueo" [control]="formActividad.get('motivoBloqueo')" 
                                                [comboBox]="listMotivosDesbloqueo" [opcion]="'description'" [idOpcion]="'id'" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col-md-3" *ngIf="this.selected.estado === 'ANDEN_CARGANDO' && this.selected.isSobrepeso">
                            <br>
                            <input type="checkbox" id="requiereDoc" name="requiereDoc" formControlName="requiereDoc"/>
                            <label for="requiereDoc">Aplica Documentos</label>
                        </div>
                        <div class="col">
                            <label for="adjuntos" class="form-control-sm">Carga de Fotos</label>
                            <input class="form-control" type="file" id="adjuntos" multiple accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" >
                            <p *ngIf="errorArchivos" style="color: red;">{{ errorArchivos }}</p>
                        </div>
                    </div>

                    <div class="btn-group col-12">
                        <button (click)="estableEstados('operador-inicio')" class="btn btn-warning col-md-4" [disabled]="this.selected.estado === 'ANDEN_CARGANDO'"> 
                        <i aria-hidden="true" class="fa fa-check"></i> Iniciar carga de Andenes</button>

                        <button (click)="estableEstados('operador-fin')" class="btn btn-primary col-md-4"> 
                        <i aria-hidden="true" class="fa fa-check"></i> Finalizar y Enviar a Sellos </button>
                    </div>
                </form>
            </div> 
        </div>
        <!-- FORMULARIO DE ACTIVIDAD  -->
         
    </ng-template>
    <!-- CUERPO -->
  </div>

    <!-- MODAL -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>
    
    <ng-template #abrirModal>
        <div class="container-fluid">
            <form [formGroup]="formulario" mat-dialog-content>
                <div class="row">
                    <div class="col" *ngIf="!isCreate">
                        <app-lfsa-input formControlName="idViaje" [label]="'ID Viaje '" [id]="'idViaje'" 
                            [isReadOnly]="true" [control]="formulario.get('idViaje')" [type]="'number'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Seleccione Tipo'" formControlName="tipo" [control]="formulario.get('tipo')" 
                                            [comboBox]="listTipos" [opcion]="'nombre'" [idOpcion]="'idTipo'" [habilitar]="!isCreate" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="placa" [label]="'* Placa'" [id]="'placa'" [control]="formulario.get('placa')" 
                        (change)="getPlaca();" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="furgon" [label]="'* Furgon'" [id]="'furgon'" [control]="formulario.get('furgon')" 
                        [type]="'text'" class="form-control-sm" (change)="getPlaca(false)" >
                        </app-lfsa-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="proveedorId" [label]="'* Código proveedor'" [id]="'proveedorId'" [control]="formulario.get('proveedorId')" 
                        [placeholder]="'Código proveedor'" (change)="getProveedor();" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="proveedorNombre" [label]="'* Detalle proveedor'" [id]="'proveedorNombre'" [control]="formulario.get('proveedorNombre')" 
                        [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="choferCedula" [label]="'* Cédula chofer'" [id]="'choferCedula'" [control]="formulario.get('choferCedula')" 
                            (change)="getChofer();" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="choferNombre" [label]="'* Detalle chofer'" [id]="'choferNombre'" [control]="formulario.get('choferNombre')" 
                            [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="choferTelefono" [label]="'* Télefono chofer'" [id]="'choferTelefono'" [control]="formulario.get('choferTelefono')" 
                            [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Seleccione Centro Destino'" formControlName="centroDestino" [control]="formulario.get('centroDestino')" 
                                            [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Seleccione Centro Carga Origen'" formControlName="centroOrigen" [control]="formulario.get('centroOrigen')" 
                                            [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" (change)="getAlmacen();" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Seleccione Bodega/Carga Origen'" formControlName="bodegaCarga" [control]="formulario.get('bodegaCarga')" 
                                            [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" >
                        </app-lfsa-combo-box>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <label for="fechaLlegada" style="font-size: .875rem;">Fecha y hora planificada de llegada</label>
                        <input autocomplete="off" class="form-control" formControlName="fechaLlegada" 
                        id="fechaLlegada" name="fechaLlegada" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                        <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('required') && this.formulario.get('fechaLlegada').touched" 
                        class="text-danger">*Campo obligatorio</small>
                    </div>

                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Estado '" formControlName="estado" [control]="formulario.get('estado')" 
                                            [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="true" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                </div>
                
                <app-lfsa-botones-formulario
                    (devolverAccion) ="acciones($event)" 
                    [formularioValido] ="formulario.invalid"
                    [mostrarBotonVerde] = "false" 
                    [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
                </app-lfsa-botones-formulario>
            </form>
        </div>
    </ng-template>
    <!-- END MODAL --> 


    <!-- MODAL SELLOS -->
    <app-lfsa-modal [innTemplate]="templateSellos" [classModal]="'modal-dialog modal-lg'" [idButton]="'ModalSellos'"  [idOpen]="'Modal3'"
                    [idClose]="'cerrarModal1'" [titulo]="'Ingresar Sellos'" ></app-lfsa-modal>
    <ng-template #templateSellos>
        <div class="container-fluid">
            <div class="card mb-3 shadow-sm viaje-card" style="border: 1px solid #f1e4c3; border-left: 5px solid #f0ad4e; border-radius: 8px;">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center flex-wrap mb-3 pb-2" style="border-bottom: 1px dashed #eadfc0;">
                        <div class="d-inline-flex align-items-center px-3 py-2" style="background:#fdf5e3; border-radius: 6px;">
                            <i class="fa fa-road" aria-hidden="true" style="color:#f0ad4e; font-size: 1.1rem;"></i>
                            <span class="font-weight-bold" style="font-size: 1rem; margin-left: 8px;">Viaje # {{ selected?.idViaje }}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-building" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Proveedor</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.proveedorNombre }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-car" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Placa</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.placa }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-truck" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Furgón</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.furgon }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-map-marker" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Número de Andén</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.andenId }}<span *ngIf="selected?.descripcionAnden"> - {{ selected?.descripcionAnden }}</span></div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-user" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Nombre del Chofer</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferNombre }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-phone" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Celular del Chofer</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferTelefono }}</div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-map-marker" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Centro Destino</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.centroDestino }} - {{ selected?.centroDestinoNombre }} <span class="text-muted">({{ selected?.clienteNombre }})</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br>
            
            <div class="row">
                <form [formGroup]="formulario" mat-dialog-content class="row p-3 border rounded">
                    <div class="row">
                        <h6> Asignación de Sellos</h6><br>
                        <div class="row">
                            <div class="col-6">
                                <app-lfsa-input formControlName="sellosAdd" [label]="'* Agregar sellos'" [id]="'sellosAdd'" [control]="formulario.get('sellosAdd')" 
                                [type]="'text'" class="form-control-sm">
                                </app-lfsa-input>
                            </div>
                            <div class="col">
                                <label> </label>
                                <div class="d-grid gap-2 d-md-block">
                                    <button (click)="agregarDetalleSellos()" class="btn btn-success" type="button"><i aria-hidden="true" class="fas fa-plus"></i></button>
                                    <button (click)="resetSellos()" class="btn btn-warning" type="button"> <i aria-hidden="true" class="fas fa-sync-alt"></i> </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span class="badge text-bg-warning mx-2 w-20" *ngFor="let opcion of this.listSello; index as i" >{{ opcion }}</span>             
                            </div>
                            <br><br> 
                        </div>                             
                        <div class="row">
                            <div class="col">
                                <app-lfsa-input formControlName="sellos" [label]="'* Sellos para viaje'" [id]="'sellos'" 
                                    [control]="formulario.get('sellos')" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                                </app-lfsa-input>
                            </div>
                        </div> 
                        <div class="row">
                            <label for="adjuntos" class="form-control-sm">Carga de Fotos</label>
                            <input class="form-control" type="file" id="adjuntos" multiple accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" >
                            <p *ngIf="errorArchivos" style="color: red;">{{ errorArchivos }}</p>
                        </div>
                        <br>
                        <!--
                        <div class="row">
                            <div class="col">
                                <button (click)="estableEstados('anden')" class="btn btn-primary" 
                                        [disabled]="formulario.get('sellos').value == '' "> 
                                    <i aria-hidden="true" class="fa fa-check"></i>Guardar Sellos
                                </button>
                                <br>
                            </div>
                        </div>    -->
                        <div class="row mt-5">
                            <button (click)="acciones('regresar')" class="btn btn-outline-danger btn-block col-md-4"><i class="fas fa-arrow-left"></i> Regresar</button>
                            <div class="col-md-4"><span class="badge text-bg-success"></span></div>
                            <button (click)="estableEstados('sellos-fin')" class="btn btn-success btn-block col-md-4"
                                    [disabled]="!formulario.get('sellos')?.value?.trim() || formulario.get('sellos')?.value?.trim().toLowerCase() === 'null'">
                                <i class="fas fa-save"></i>Enviar a Documentos
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </ng-template>
    <!-- END MODAL -->


    <!-- MODAL ANDENES -->
    <app-lfsa-modal [innTemplate]="templateAndenes" [classModal]="'modal-dialog modal-lg'" [idButton]="'ModalAnden'" [idOpen]="'Modal4'"
                    [idClose]="'cerrarModal2'" [titulo]="'Asignar Anden'" ></app-lfsa-modal>
    <ng-template #templateAndenes>
        <div class="container-fluid">
            <div class="card mb-3 shadow-sm viaje-card" style="border: 1px solid #f1e4c3; border-left: 5px solid #f0ad4e; border-radius: 8px;">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center flex-wrap mb-3 pb-2" style="border-bottom: 1px dashed #eadfc0;">
                        <div class="d-inline-flex align-items-center px-3 py-2" style="background:#fdf5e3; border-radius: 6px;">
                            <i class="fa fa-road" aria-hidden="true" style="color:#f0ad4e; font-size: 1.1rem;"></i>
                            <span class="font-weight-bold" style="font-size: 1rem; margin-left: 8px;">Viaje # {{ selected?.idViaje }}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-sm-6 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-building" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Proveedor</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.proveedorNombre }}</div>
                            </div>
                        </div>

                        <div class="col-md-6 col-sm-6 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-car" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Placa</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.placa }}</div>
                            </div>
                        </div>

                        <div class="col-md-6 col-sm-6 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-truck" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Furgón</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.furgon }}</div>
                            </div>
                        </div>

                        <div class="col-md-6 col-sm-6 d-flex align-items-start mb-3">
                            <div class="d-flex align-items-center justify-content-center" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                                <i class="fa fa-map-marker" aria-hidden="true" style="color:#b0894a;"></i>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Centro Destino</div>
                                <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.centroDestino }} - {{ selected?.centroDestinoNombre }} <span class="text-muted">({{ selected?.clienteNombre }})</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div>

            <div class="row p-3">
                <form [formGroup]="formAnden" mat-dialog-content class="row p-3 border rounded">
                    <div class="row">
                        <h6> Asignación de Andenes</h6><br>
                        <div class="col">
                            <app-lfsa-combo-box [label]="'Centro Destino'" formControlName="centroDestino" [control]="formAnden.get('centroDestino')"
                                                [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm" [habilitar]="true">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Centro Carga Origen'" formControlName="centroOrigen" [control]="formAnden.get('centroOrigen')" 
                                                [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm" [habilitar]="true">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Bodega/Carga Origen'" formControlName="bodegaCarga" [control]="formAnden.get('bodegaCarga')" 
                                                [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" [habilitar]="true">
                            </app-lfsa-combo-box>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <span *ngIf="CentroAlmacen == null"> No hay muelles el para Centro-almacen </span>
                            <app-lfsa-input formControlName="texto" [label]="'* Texto traslado Centro-Almacen'" [id]="'texto'" [control]="formAnden.get('texto')" 
                            [type]="'text'" class="form-control-sm" aria-readonly="true" [isReadOnly]="true" >
                            </app-lfsa-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Seleccionar anden'" id="andenId" formControlName="andenId" [control]="formAnden.get('andenId')" 
                                                [comboBox]="listAdenes" [opcion]="'nombre'" [idOpcion]="'idMuelle'" class="form-control-sm" >
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Seleccionar area'" id="areaId" formControlName="areaId" [control]="formAnden.get('areaId')" 
                                                [comboBox]="listAreas" [opcion]="'descArea'" [idOpcion]="'idArea'" class="form-control-sm" >
                            </app-lfsa-combo-box>
                        </div>
                    </div>        
                </form>

                <div class="row mt-4 mb-2">
                    <button (click)="acciones('regresar')" class="btn btn-outline-danger btn-block col-md-4"><i class="fas fa-arrow-left"></i> Regresar</button>
                    <div class="col-md-4"><span class="badge text-bg-success"></span></div>
                    <button (click)="estableEstados('anden-fin')" class="btn btn-success btn-block col-md-4"><i class="fas fa-save"></i> Iniciar Carga</button>
                </div>           
            </div>
        </div>
    </ng-template>
    <!-- END MODAL -->
